import { StyleConfigModel } from "../types";

export type ThemePreset = {
  id: string;
  label: string;
  description: string;
  patch: Partial<StyleConfigModel>;
};

// Partial style patches applied on top of existing working styleConfig.
// Covers: header bg (backgroundColor), header text, frame (chat) bg/text,
// visitor bubble bg/text, agent bubble bg/text/border, accent (actionColor).
export const THEME_PRESETS: ThemePreset[] = [
  {
    id: "light",
    label: "Light",
    description: "Clean, bright, default Velaro look",
    patch: {
      backgroundColor: "#1670E7",
      headerTextColor: "#FFFFFF",
      frameBackgroundColor: "#F8FAFC",
      frameTextColor: "#1E293B",
      agentBubbleBgColor: "#FFFFFF",
      agentBubbleTextColor: "#161616",
      agentBubbleBorderColor: "#E2E8F0",
      visitorBubbleBgColor: "#1670E7",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#1670E7",
      useContrastedColorHeader: false,
      useContrastedColorBody: false
    }
  },
  {
    id: "dark",
    label: "Dark",
    description: "Slate dark with blue accent",
    patch: {
      backgroundColor: "#0F172A",
      headerTextColor: "#F1F5F9",
      frameBackgroundColor: "#1E293B",
      frameTextColor: "#E2E8F0",
      agentBubbleBgColor: "#334155",
      agentBubbleTextColor: "#F1F5F9",
      agentBubbleBorderColor: "#475569",
      visitorBubbleBgColor: "#3B82F6",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#3B82F6",
      useContrastedColorHeader: false,
      useContrastedColorBody: false
    }
  },
  {
    id: "midnight",
    label: "Midnight",
    description: "Deep purple night",
    patch: {
      backgroundColor: "#1E1B4B",
      headerTextColor: "#E0E7FF",
      frameBackgroundColor: "#0F0D2D",
      frameTextColor: "#C7D2FE",
      agentBubbleBgColor: "#312E81",
      agentBubbleTextColor: "#E0E7FF",
      agentBubbleBorderColor: "#4338CA",
      visitorBubbleBgColor: "#6366F1",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#818CF8"
    }
  },
  {
    id: "ocean",
    label: "Ocean",
    description: "Teal and deep sea blue",
    patch: {
      backgroundColor: "#0E7490",
      headerTextColor: "#ECFEFF",
      frameBackgroundColor: "#F0FDFA",
      frameTextColor: "#134E4A",
      agentBubbleBgColor: "#FFFFFF",
      agentBubbleTextColor: "#134E4A",
      agentBubbleBorderColor: "#A7F3D0",
      visitorBubbleBgColor: "#0E7490",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#06B6D4"
    }
  },
  {
    id: "forest",
    label: "Forest",
    description: "Calm green tones",
    patch: {
      backgroundColor: "#166534",
      headerTextColor: "#F0FDF4",
      frameBackgroundColor: "#F7FEE7",
      frameTextColor: "#14532D",
      agentBubbleBgColor: "#FFFFFF",
      agentBubbleTextColor: "#14532D",
      agentBubbleBorderColor: "#BBF7D0",
      visitorBubbleBgColor: "#16A34A",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#22C55E"
    }
  },
  {
    id: "sunset",
    label: "Sunset",
    description: "Warm orange and rose",
    patch: {
      backgroundColor: "#C2410C",
      headerTextColor: "#FFF7ED",
      frameBackgroundColor: "#FFF7ED",
      frameTextColor: "#7C2D12",
      agentBubbleBgColor: "#FFFFFF",
      agentBubbleTextColor: "#7C2D12",
      agentBubbleBorderColor: "#FED7AA",
      visitorBubbleBgColor: "#EA580C",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#F97316"
    }
  },
  {
    id: "monochrome",
    label: "Monochrome",
    description: "Grayscale minimal",
    patch: {
      backgroundColor: "#111827",
      headerTextColor: "#F9FAFB",
      frameBackgroundColor: "#FFFFFF",
      frameTextColor: "#111827",
      agentBubbleBgColor: "#F3F4F6",
      agentBubbleTextColor: "#111827",
      agentBubbleBorderColor: "#E5E7EB",
      visitorBubbleBgColor: "#111827",
      visitorBubbleTextColor: "#FFFFFF",
      actionColor: "#374151"
    }
  }
];
